import { Injectable, inject } from '@angular/core';

import { WindowRef } from '@frontend/vanilla/core';
import { ChatRequest, PaymentsCommonConfig, SprinklrChatService } from '@payments/common-utils';

import { UrlConstants } from '../config/urlConstants';
import { GtmService } from './gtm.service';
import { QdApiService } from './qd.service';
import { UserDataService } from './userDataService';

@Injectable({
    providedIn: 'root',
})
export class ChatService {
    private userDataService = inject(UserDataService);
    private gtmService = inject(GtmService);
    private apiService = inject(QdApiService);
    private WindowRef = inject(WindowRef);
    private sprinklrChatService = inject(SprinklrChatService);

    chatErrorCodes = ['1001', '1000'];
    labelDomain = '';
    zendeskEnabled: any;
    pullchatEnabled;
    zendeskErrorCode: any;
    userCountry;
    websiteUrl;
    commonEventData: any = {
        'component.CategoryEvent': 'hcc',
        'component.LabelEvent': 'livechat',
        'component.PositionEvent': 'not applicable',
        'component.LocationEvent': 'not applicable',
        'component.EventDetails': 'chat window',
        'component.URLClicked': 'not applicable',
    };
    trackingEvents = {
        zendesk_load: {
            ...this.commonEventData,
            'component.ActionEvent': 'load',
        },
        zendesk_blocked_account: {
            ...this.commonEventData,
            'component.ActionEvent': 'account name disabled',
        },
        zendesk_blocked_ip: {
            ...this.commonEventData,
            'component.ActionEvent': 'blocked ip disabled',
        },
        zendesk_service_unavailable_all: {
            ...this.commonEventData,
            'component.ActionEvent': 'unavailable',
        },
    };
    private readonly paymentsCommonConfig = inject(PaymentsCommonConfig);
    constructor() {
        const userDataService = this.userDataService;

        this.zendeskEnabled = userDataService?.userData?.configParams.zendeskEnabled === 'Y';
        this.pullchatEnabled = userDataService?.userData?.configParams.pullchatEnabled === 'Y';
        this.zendeskErrorCode = 0;
        this.userCountry = userDataService?.userData?.userInfo?.addressInfo?.country;
        this.websiteUrl = userDataService?.userData?.configParams?.pullchatWebsiteUrl;
        if (this.userDataService?.userData?.configParams?.pullchatWebsiteUrl) {
            const pullChatURl = this.userDataService?.userData?.configParams?.pullchatWebsiteUrl;
            const labelIndex = pullChatURl.indexOf('-') + 1;
            this.labelDomain = pullChatURl.substring(labelIndex);
        }
    }

    triggerChat(callback: any) {
        if (this.zendeskEnabled) {
            this.apiService.get(UrlConstants.ZENDESK_CHAT_TOKEN).subscribe((response) => {
                if (response?.data) {
                    this.zendeskErrorCode = response.data.code;
                    callback(this.zendeskErrorCode);
                }
            });

            const adaWebsiteUrl = document.querySelector('#adaPullchatUrl');
            if (adaWebsiteUrl) {
                this.websiteUrl =
                    this.userCountry === 'GB' ? 'unusualdeposits' + '-' + this.labelDomain : 'arc-int-unusualdeposits' + '-' + this.labelDomain;
            }
            const hardStopWebsiteUrl = document.querySelector('#hardStopchatUrl');
            if (hardStopWebsiteUrl) {
                this.websiteUrl = 'cashierhardstop' + '-' + this.labelDomain;
            }
            if (this.chatErrorCodes.indexOf(this.zendeskErrorCode) != -1) {
                if (this.zendeskErrorCode === '1001') {
                    this.gtmService.raiseComponentEvent('Event.Tracking', this.trackingEvents.zendesk_blocked_ip);
                } else if (this.zendeskErrorCode === '1000') {
                    this.gtmService.raiseComponentEvent('Event.Tracking', this.trackingEvents.zendesk_blocked_account);
                }
            } else {
                if (this.paymentsCommonConfig.sprinklrEnabled) {
                    if (this.sprinklrChatService?.isSprinklrInitialized()) {
                        this.sprinklrChatService.openLiveChat(this.websiteUrl);
                    } else {
                        const sprinklrChatRequest: ChatRequest = {
                            websiteUrl: this.websiteUrl,
                            ipAddress: this.userDataService.userData?.clientInfo?.ip,
                        };
                        this.sprinklrChatService?.initializeSprinklrChat(sprinklrChatRequest, 'qd-app');
                    }
                } else {
                    if (this.WindowRef?.nativeWindow?.gvczendesk?.initLiveChat) {
                        this.WindowRef?.nativeWindow?.gvczendesk?.initLiveChat('', this.websiteUrl);
                    }
                    this.gtmService.raiseComponentEvent('Event.Tracking', this.trackingEvents.zendesk_load);
                }
            }
        } else if (this.websiteUrl?.value) {
            if (this.WindowRef?.nativeWindow?.gvczendesk?.initLiveChat) {
                this.WindowRef?.nativeWindow?.gvczendesk?.initLiveChat('', this.websiteUrl);
            }
        }
        if (!this.zendeskEnabled && !this.pullchatEnabled) {
            this.gtmService.raiseComponentEvent('Event.Tracking', this.trackingEvents.zendesk_service_unavailable_all);
        }
    }
}
